'use strict';

(function() {
	var app = angular.module('onboarding.carrier');
	app.directive('cobCarrierProfileTaxes', cobCarrierProfileTaxes);
	app.constant('SSN_PLACEHOLDER', 'SSN, such as ### - ## - ####');
	app.constant('SIN_PLACEHOLDER', 'SIN, such as ### - ### - ###');
	app.constant('EIN_PLACEHOLDER', 'EIN, such as ## - #######');

	cobCarrierProfileTaxes.$inject = [
		'sessionService', 'subjectObserverMessagesService', 'observerService', 'carrierRegistrationService', '$timeout',
		'$location', '$stateParams'
	];

	var
		sessionService,
		subjectObserverMessagesService,
		observerService,
		carrierRegistrationService,
		$timeout,
		$location,
		$stateParams;
	var subjectMessages, observerMessages;

	function cobCarrierProfileTaxes(_sessionService_,
		_subjectObserverMessagesService_,
		_observerService_,
		_carrierRegistrationService_,
		_$timeout_,
		_$location_,
		_$stateParams_) {
		sessionService = _sessionService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierRegistrationService = _carrierRegistrationService_;
		$timeout = _$timeout_;
		$location = _$location_;
		$stateParams = _$stateParams_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/carrierProfileTaxes.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			registerObserverHandlers();
			document.title = 'Profile-Tax';

			$timeout(function() {
				observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_LOAD);
				loadData();
			},
			100);
		}

		function loadData() {
			carrierRegistrationService.getCarrierTaxInfo($stateParams.carrierId)
				.then(function(response) {
					if (response.data.w8TaxInfo) {
						var w8Data = {};

						w8Data.name = response.data.w8TaxInfo.name;

						if (response.data.w8TaxInfo.beneficialOwnerType) {
							w8Data.beneficialOwnerType = response.data.w8TaxInfo.beneficialOwnerType;
						} else {
							w8Data.beneficialOwnerType = '--';
						}

						if (response.data.w8TaxInfo.federalTaxIdType === 'EIN') {
							w8Data.ein = response.data.w8TaxInfo.tin;
						} else if (response.data.w8TaxInfo.federalTaxIdType === 'SSN') {
							w8Data.ssn = response.data.w8TaxInfo.tin;
						}

						if (response.data.w8TaxInfo.foreignTaxIdType === 'SIN') {
							w8Data.sin = response.data.w8TaxInfo.foreignTaxId;
						} else if (response.data.w8TaxInfo.foreignTaxIdType === 'BN') {
							w8Data.bn = response.data.w8TaxInfo.foreignTaxId;
						}

						w8Data.formYear = response.data.w8TaxInfo.formYear;
						w8Data.incorporationCountry = response.data.w8TaxInfo.incorporationCountry;

						w8Data.streetAddress = response.data.w8TaxInfo.streetAddress;
						w8Data.city = response.data.w8TaxInfo.city;
						w8Data.state = response.data.w8TaxInfo.state;
						w8Data.postalCode = response.data.w8TaxInfo.postalCode;
						w8Data.country = response.data.w8TaxInfo.country;


						if (
							response.data.w8TaxInfo.mailingStreet === w8Data.streetAddress &&
                                response.data.w8TaxInfo.mailingCity === w8Data.city &&
                                response.data.w8TaxInfo.mailingCountry === w8Data.country &&
                                response.data.w8TaxInfo.mailingPostalCode === w8Data.postalCode &&
                                response.data.w8TaxInfo.mailingState === w8Data.state) {
							w8Data.mailingSameAsPermanent = true;
						} else {
							w8Data.mailingSameAsPermanent = false;
							w8Data.mailingCity = response.data.w8TaxInfo.mailingCity;
							w8Data.mailingCountry = response.data.w8TaxInfo.mailingCountry;
							w8Data.mailingPostalCode = response.data.w8TaxInfo.mailingPostalCode;
							w8Data.mailingState = response.data.w8TaxInfo.mailingState;
							w8Data.mailingStreet = response.data.w8TaxInfo.mailingStreet;
						}

						if (!w8Data.mailingStreet && !w8Data.mailingCity && !w8Data.mailingPostalCode) {
							w8Data.mailingSameAsPermanent = true;
						}


						observerService
							.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_CARRIER_PROFILE_W8_LOADED, w8Data);
					} else if (response.data.w9TaxInfo) {
						var w9Data = {};
						w9Data.taxStatus = response.data.w9TaxInfo.taxStatus;
						w9Data.exemptionType = 0;
						w9Data.name = response.data.w9TaxInfo.name;
						w9Data.businessName = response.data.w9TaxInfo.businessName;
						w9Data.streetAddress = response.data.w9TaxInfo.streetAddress;
						w9Data.cityAddress = response.data.w9TaxInfo.city;
						w9Data.postalCodeAddress = response.data.w9TaxInfo.postalCode;

						if (response.data.w9TaxInfo.state) {
							w9Data.stateAddress = response.data.w9TaxInfo.state;
						} else {
							w9Data.stateAddress = '--';
						}

						if (response.data.w9TaxInfo.taxClassification) {
							w9Data.federalType = response.data.w9TaxInfo.taxClassification;

							if (w9Data.federalType === 'Other') {
								w9Data.federalTypeOther = response.data.w9TaxInfo.otherText;
							}
						} else {
							w9Data.federalType = '--';
						}

						if (response.data.w9TaxInfo.exemptPayeeCode) {
							w9Data.exemptionType = parseInt(response.data.w9TaxInfo.exemptPayeeCode);
						} else {
							w9Data.exemptionType = '0';
						}

						if (response.data.w9TaxInfo.fatcaReportingCode) {
							w9Data.reportCode = response.data.w9TaxInfo.fatcaReportingCode;
						} else {
							w9Data.reportCode = '--';
						}

						if (response.data.w9TaxInfo.federalTaxIdType === 'EIN') {
							w9Data.eid = response.data.w9TaxInfo.tin;
						}

						if (response.data.w9TaxInfo.federalTaxIdType === 'SSN') {
							w9Data.ssn = response.data.w9TaxInfo.tin;
						}

						observerService
							.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_CARRIER_PROFILE_W9_LOADED, w9Data);
					}
				})
				.catch(function(e) {
					console.log(e);
				});
		}

		function registerObserverHandlers() {

			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_CARRIER_PROFILE_TAX_RELOAD, handler: loadData }
				]);
		}
	}

})();
